import React, { useState } from "react";
import { functionsBaseUrl } from "../config/runtime";
import ProgressBar from "./ProgressBar";
import CustomRadio from "./CustomRadio";

// Step 1
const Step1 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "printerUse";
    const selectedOption = formData[key] || "";
    const options = [
        "Printing documents",
        "Printing photos/graphics",
        "Scanning/copying",
        "Bulk printing (high volume)",
        "Mixed office tasks"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                What will you mainly use the printer for?
            </h2>
            <ProgressBar step={1} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <div className="w-5" />
                {/* <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button> */}
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// Step 2
const Step2 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "pagesPerMonth";
    const selectedOption = formData[key] || "";
    const options = [
        "0 - 500  Pages",
        "500 - 2000 Pages",
        "2000 - 5000 Pages",
        "5000 - 20 000 Pages",
        "Over 20 000 Pages"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                How many pages do you print per month?
            </h2>
            <ProgressBar step={2} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// Step 3
const Step3 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "colorPreference";
    const selectedOption = formData[key] || "";
    const options = [
        "Colour",
        "Black & White",
        "Both, but colour is rarely needed"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                Do you need colour printing or is black & white enough?
            </h2>
            <ProgressBar step={3} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// Step 4
const Step4 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "printerType";
    const selectedOption = formData[key] || "";
    const options = [
        { label: "Laser", desc: "Fast, efficient for text" },
        { label: "Inkjet", desc: "Better for images / photos" },
        { label: "No preference - Need recommendation" }
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                What type of printer do you prefer?
            </h2>
            <ProgressBar step={4} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option.label || option}
                        label={option.label || option}
                        desc={option.desc}
                        value={option.label || option}
                        selected={selectedOption === (option.label || option)}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// Step 5
const Step5 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "printerSpeed";
    const selectedOption = formData[key] || "";
    const options = [
        { label: "Normal Office Speed", desc: "20-30 PPM" },
        { label: "High speed", desc: "30-50 PPM" },
        { label: "Very high speed", desc: "50+ PPM" },
        "Not a priority"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                How fast should the printer be
            </h2>
            <ProgressBar step={5} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option.label || option}
                        label={option.label || option}
                        desc={option.desc}
                        value={option.label || option}
                        selected={selectedOption === (option.label || option)}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// Step 6 (similar)
const Step6 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "multifunction";
    const selectedOption = formData[key] || "";
    const options = [
        "Copying",
        "Scan",
        "Fax",
        "Wireless printing",
        "Mobile printing",
        "Duplex (Double-sided) printing"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                Select all multifunction features that apply:
            </h2>
            <ProgressBar step={6} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>
            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>
            </div>
        </div>
    );
};


const Step7 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "peopleSharingPrinter";
    const selectedOption = formData[key] || "";
    const options = [
        "Just me",
        "2-5 people",
        "6-15 people",
        "More than 15 people"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                How many people will share the printer?
            </h2>

            <ProgressBar step={7} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>

            </div>

        </div>
    );
};

const Step8 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "paperSize";
    const selectedOption = formData[key] || "";
    const options = [
        "A4 only",
        "A4 & legal",
        "A3 & A4",
        "Other"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                What paper size do you need to print?
            </h2>

            <ProgressBar step={8} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>

            </div>

        </div>
    );
};


const Step9 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "printQuality";
    const selectedOption = formData[key] || "";
    const options = [
        "Basic Office Quality",
        "High Quality For Presentations",
        "Professional Graphic/Photo Quality",
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                How important is print quality?
            </h2>

            <ProgressBar step={9} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}
                >
                    Continue
                </button>

            </div>

        </div>
    );
};


const Step10 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "securePrinting";
    const selectedOption = formData[key] || "";
    const options = [
        "Yes, Secure / password printing",
        "Yes, Printing Logs / Audit Trail",
        "No, Standard Printing Is Fine",
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                Do you need secure or confidential printing features?
            </h2>

            <ProgressBar step={10} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>

            </div>

        </div>
    );
};

const Step11 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "rentalDuration";
    const selectedOption = formData[key] || "";
    const options = [
        "36 months",
        "48 months",
        "60 months",
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                What is your preferred rental duration?
            </h2>

            <ProgressBar step={11} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>

            </div>

        </div>
    );
};

const Step12 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "budget";
    const selectedOption = formData[key] || "";
    const options = [
        "Low budget",
        "Mid-range",
        "High performance, cost is not a concern",
        "Not sure - recommend options"
    ];

    return (
        <div className="flex flex-col items-start gap-3">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                What is your approximate budget per month?
            </h2>

            <ProgressBar step={12} totalSteps={14} />
            <div className="flex flex-col gap-4 w-full">
                {options.map(option => (
                    <CustomRadio
                        key={option}
                        label={option}
                        value={option}
                        selected={selectedOption === option}
                        onChange={val => setAnswer(key, val)}
                    />
                ))}
            </div>

            <div
                className="flex items-center justify-between w-full mt-6"
            >
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!selectedOption}

                >
                    Continue
                </button>

            </div>

        </div>
    );
};

const Step13 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const key = "specialRequirements";
    const value = formData[key] || "";

    return (
        <div className="flex flex-col items-start gap-3 w-full">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                Any special requirements?
            </h2>

            <ProgressBar step={13} totalSteps={14} />

            <textarea
                className="w-full p-4 mt-4 rounded-xl bg-white border border-[#1C555126] text-gray-800 placeholder-gray-400 focus:outline-none"
                placeholder="E.G., Quiet Operation, Compact Size, Large Paper Trays, Heavy Card Stock Printing, MAC Compatibility"
                value={value}
                onChange={e => setAnswer(key, e.target.value)}
                rows={8}
            />

            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={nextStep}
                    disabled={!value.trim()}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

const Step14 = ({ nextStep, previousStep, formData, setAnswer }) => {
    const [submitting, setSubmitting] = useState(false);
    const fields = [
        { key: "businessName", label: "Business Name", placeholder: "Enter your business name" },
        { key: "contactName", label: "Contact Name", placeholder: "Enter your full name" },
        { key: "email", label: "Email Address", type: "email", placeholder: "your.email@company.com" },
        { key: "phone", label: "Phone Number", type: "tel", placeholder: "+27 (0) 12 345 6789" },
        { key: "city", label: "City / Region", placeholder: "Enter your city or region" },
    ];
    const allFilled = fields.every(field => formData[field.key]?.trim());


    const handleChange = (key, value) => {
        setAnswer(key, value);
    };

    const handleFinish = async () => {
        if (!allFilled) {
            alert("Please fill all required fields");
            return;
        }

        try {
            setSubmitting(true);

            const {
                businessName,
                contactName,
                email,
                phone,
                city,
                specialRequirements,
                ...surveyAnswers
            } = formData;

            const smtpResponse = await fetch(`${functionsBaseUrl}/sendNewEmail`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: "survey_referral",
                    payload: {
                        businessName,
                        contactName,
                        email,
                        phone,
                        city,
                        specialRequirements,
                        answers: surveyAnswers,
                    },
                }),
            });

            const smtpData = await smtpResponse.json();

            if (!smtpResponse.ok || smtpData.data?.failed > 0) {
                console.error("SMTP2GO error:", smtpData);
                throw new Error("Email failed");
            }

            console.log("Email sent successfully");
            nextStep();

        } catch (err) {
            console.error("Axios error:", {
                message: err.message,
                responseData: err.response?.data,
                headers: err.response?.headers,
                status: err.response?.status,
            });
            alert("Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <div className="flex flex-col items-start gap-4 w-full">
            <h2 className="text-secondary font-20 md:text-[30px] font-bold custom-font text-left">
                Almost done! Let's get your contact details
            </h2>

            <p className="text-[#0A0A0A] font-medium">
                We'll send your personalized printer recommendation to this contact
            </p>

            <ProgressBar step={14} totalSteps={14} />

            <div className="flex flex-col gap-4 w-full mt-4">
                {fields.map(field => (
                    <div key={field.key} className="flex flex-col w-full">
                        <label className="text-gray-800 font-medium mb-2">
                            {field.label} <span className="text-red-600">*</span>
                        </label>
                        <input
                            type={field.type || "text"}
                            required
                            className="w-full p-4 rounded-xl bg-white border border-[#1C555126] text-gray-800 placeholder-gray-400 focus:outline-none"
                            placeholder={field.placeholder}
                            value={formData[field.key] || ""}
                            onChange={e => handleChange(field.key, e.target.value)}
                        />
                    </div>
                ))}
            </div>

            <div className="flex items-center justify-between w-full mt-6">
                <button
                    className="btn-grey px-6 py-3 rounded-xl font-semibold"
                    onClick={previousStep}
                    style={{ color: '#000000b3' }}
                >
                    Back
                </button>
                <button
                    className="btn-primary text-white px-6 py-3 rounded-xl font-semibold"
                    onClick={handleFinish}
                    disabled={!allFilled || submitting}

                >
                    {submitting ? "Submitting..." : "Finish"}
                </button>
            </div>
        </div>
    );
};

export default Step14;


export {
    Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9, Step10, Step11, Step12, Step13, Step14
};
